// extracted by mini-css-extract-plugin
module.exports = {"container":"_2LALr5VzEVKiRCRD55Ro3m","row":"SQvA7MDPOkls0ZRMFQ6CS","developers":"_2qt6ypSb6hWyF6rDW2KgqI","action":"_2H7C1MSa82K1byYatlPnYw"};